import ZoomButtons from './ZoomButtons';

export default ZoomButtons;
